import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Avatar/Avatar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Breadcrumbs/Breadcrumbs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Link/Link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/news/BreadcrumbsRow/share-this.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsHero/NewsTags/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsHero/NewsAuthor/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsHero/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsBody/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsBody/raw-html-styles.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/BreadcrumbsRow/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsTags/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/NewsCategoriesFooter/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/news-media-contact/styles.module.css");
